import { render, staticRenderFns } from "./Cakto.vue?vue&type=template&id=3333bcd4&"
import script from "./Cakto.vue?vue&type=script&lang=js&"
export * from "./Cakto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports